import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus'

const Subnav = () => {
    const subnavDom = document.querySelectorAll('.sub-nav');   
    
    let subnavConstructor = (id) => {
        Vue.component('subnav-template', {
            data: function() {
                return {
                    isMobile: store.state.isMobile,
                    anchors: store.state.pageAnchors,
                }
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
                // computedShowAnchors: function() {
                //     return store.state.showInlineAnchors;
                // }
            },
            watch: {
                computedIsMobile() {
                    this.isMobile = this.computedIsMobile;
                },
                // computedShowAnchors() {
                //     this.showAnchors = this.computedShowAnchors;
                // }
            },
            methods: {
                
            },
            mounted() {
                
            }
        });

        Vue.component('subnav-desktop', {
            props: ['isMobile'],
            data: function() {
                return {

                }
            },
            methods: {

            },
            mounted() {

            }
        });

        Vue.component('subnavDropdown', {
            props: ['anchors'],
            data: function() {
                return {

                }
            },
            template: `
            <select name="pageSection" class="persistent-cta__dropdown persistent-cta__dropdown--inline" :anchor=anchors v-on:change="jump">
                <anchor-dropdown-item v-for="(item, index) in anchors" :key="index" :data="item"/>
            </select>
            `,
            methods: {
                jump(e) {
                    window.location.hash = `#${e.target.value}`;
                    //console.log(e.target.value);
                }
            },
            mounted() {
                
            }
        });

        Vue.component('anchor-dropdown-item', {
            props: ['data'],
            data: function() {
                return {

                }
            },
            template: `
                <option :value="data.key">{{data.name}}</option>
            `,
            methods: {

            },
            mounted() {
                
            }
        });

        new Vue({
            el: `.subnav-${id}`,
        }).$mount(`.subnav-${id}`, true);
    }

    if (subnavDom.length > 0 ) {
        subnavDom.forEach((item, index) => {
            item.classList.add(`subnav-${index}`);
            subnavConstructor(index);
        })
    }

}

export default Subnav;